module.exports = __webpack_public_path__ + "media/images/posts-c937be092fb2763acdc76f9c67031d4c.png";